import { render, staticRenderFns } from "./MY23BMWi7-disclosure.vue?vue&type=template&id=0a53679a&"
import script from "./MY23BMWi7-disclosure.vue?vue&type=script&lang=js&"
export * from "./MY23BMWi7-disclosure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports